import './index.css';

function BlurScreen() {
    return (
        <div className={'table-blur'} />
    );
}

export default BlurScreen;